import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { fetchGetHeadBanners } from '../../../actions/banners';

const Banners = () => {
  const dispatch = useDispatch();
  const [banners, setBanners] = useState([]);
  const [closedBanners, setClosedBanners] = useState([]);

  const closedBannersLocalStorageRaw = localStorage.getItem('ClosedHeaderBanners');
  const closedHeaderBannersLocalStorage = useMemo(() => {
    let correctClosedBanners = closedBannersLocalStorageRaw || [];
    if (typeof correctClosedBanners === 'string') {
      correctClosedBanners = JSON.parse(closedBannersLocalStorageRaw);
    }
    return correctClosedBanners;
  }, [closedBannersLocalStorageRaw]);

  const getBanners = async () => {
    const result = await dispatch(fetchGetHeadBanners());
    setBanners(result);
  };

  const hideBanner = (bannerId) => {
    const newClosedHeaderBanners = [...closedHeaderBannersLocalStorage, bannerId];
    localStorage.setItem('ClosedHeaderBanners', JSON.stringify(newClosedHeaderBanners));
    setClosedBanners(newClosedHeaderBanners);
  };

  useEffect(() => {
    (async function () {
      await getBanners();
    })();
    setClosedBanners(closedHeaderBannersLocalStorage);
  }, []);

  return (
    <div className="headerBanners">
      {banners.map((banner) => {
        if (closedBanners.includes(banner.id)) {
          return null;
        }
        return (
          <div className="headerBanner" key={banner.id}>
            <a target="_blank" rel="noopener noreferrer" href={banner.targetUrl}>
              <img src={banner.imageUrl} alt="headerBanner" />
            </a>
            <button
              type="button"
              className="close"
              onClick={() => {
                hideBanner(banner.id);
              }}
            >
              ×
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default Banners;
